module.exports = __webpack_public_path__ + "static/media/6S.0d7fd9f2.svg";